export const theme = {
  colors: {
    // Primary colors
    primary: '#ff6b6b',
    primaryHover: '#ee5a52',
    primaryLight: '#ffa8a8',

    // Secondary colors
    secondary: '#4ecdc4',
    secondaryHover: '#3dbdb5',
    secondaryLight: '#7ee8e1',

    // Dark theme colors
    background: '#0d0d1a',
    backgroundLight: '#1a1a2e',
    backgroundLighter: '#252542',

    // Text colors
    text: '#ffffff',
    textSecondary: '#b8b8d4',
    textMuted: '#7a7a9a',

    // Accent colors
    accent: '#f9a826',
    accentPurple: '#a855f7',
    accentPink: '#ec4899',

    // Status colors
    success: '#10b981',
    warning: '#f59e0b',
    error: '#ef4444',
    info: '#3b82f6',

    // Gradients
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    gradientDark: 'linear-gradient(135deg, #0d0d1a 0%, #1a1a2e 100%)',
    gradientPrimary: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%)',
  },

  breakpoints: {
    xs: '375px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  },

  fonts: {
    primary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif",
    heading: "'Orbitron', sans-serif",
    mono: "'Fira Code', 'Courier New', monospace",
    sizes: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
      '5xl': '3rem',
      '6xl': '3.75rem',
      '7xl': '4.5rem',
    },
  },

  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
    '3xl': '4rem',
    '4xl': '6rem',
    '5xl': '8rem',
  },

  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
    '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    glow: '0 0 20px rgba(255, 107, 107, 0.3)',
    glowSecondary: '0 0 20px rgba(78, 205, 196, 0.3)',
  },

  borderRadius: {
    none: '0',
    sm: '0.25rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
    '2xl': '1.5rem',
    full: '9999px',
  },

  transitions: {
    fast: '150ms ease-in-out',
    base: '300ms ease-in-out',
    slow: '500ms ease-in-out',
  },

  zIndex: {
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modalBackdrop: 1040,
    modal: 1050,
    popover: 1060,
    tooltip: 1070,
  },
}
